import { render, staticRenderFns } from "./MobileAccountCheck.vue?vue&type=template&id=5f2d8c28&"
import script from "./MobileAccountCheck.vue?vue&type=script&lang=js&"
export * from "./MobileAccountCheck.vue?vue&type=script&lang=js&"
import style0 from "./MobileAccountCheck.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports